// Build-time feature switches (Vite inlines VITE_* at build; a change needs a
// redeploy). Compare against the literal string — env values are never booleans.

// Termy, the AI/manual chat assistant for adding tasks. Off unless explicitly
// enabled: hides the sidebar launcher, the `t` hotkey and the palette entry.
export const TERMY_ENABLED = import.meta.env.VITE_TERMY_ENABLED === 'true';
